import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { CMSEditOverlay } from "../../components/cms/edit-overlay/CMSEditOverlay";
import { LocaleSuggestionOverlayFromPageData } from "../locale-suggestion-overlay-from-page-data";
import { AnnouncementBarComponent } from "../../components/AnnouncementBarComponent/AnnouncementBarComponent";
import React, { useEffect } from "react";
import { SwarovskiPageDataFrontend } from "@swo/storefront";
import { PublicConfigurationT, getIsoCodeWithIntFallback } from "@swo/shared";
import { useIntercomChatbot } from "./use-intercom-chatbot";
import { NewsletterPopup } from "../newsletter-popup/newsletter-popup";
import { useStore } from "../../store/hooks/use-store";
import { getNewsletterConfiguration } from "./getNewsletterConfiguration";

export const CommonRouteElements: ReactTFC<{
  pageData: SwarovskiPageDataFrontend;
  intercom: PublicConfigurationT["integrations"]["intercom"];
}> = props => {
  const { pageData, intercom } = props;
  const { state } = useStore();

  const { isNewsletterShown, newsletterData } = getNewsletterConfiguration(state.config, pageData);

  const {
    locale,
    dataOrError,
    __typename,
    generalTranslations,
    localeSuggestionOverlayTranslation,
    segment,
    termsAndConditionsPageLink,
    privacyPolicyPageLink,
    announcementBar,
  } = pageData;

  useIntercomChatbot(
    intercom?.appId,
    intercom?.appApiBase,
    intercom?.usercentricsServiceId,
    locale.chatbotEnabled,
    locale.language.isoCode,
    getIsoCodeWithIntFallback(locale.country),
  );

  const positionStatically = __typename === "CheckoutPage";

  return (
    <>
      <CMSEditOverlay pageData={pageData} />

      <LocaleSuggestionOverlayFromPageData
        data={dataOrError}
        locale={locale}
        generalTranslations={generalTranslations}
        localeSuggestionsTranslations={localeSuggestionOverlayTranslation}
      />

      {isNewsletterShown && newsletterData && (
        <NewsletterPopup
          locale={locale}
          segment={segment}
          links={{
            termsAndConditions: termsAndConditionsPageLink,
            privacyPolicy: privacyPolicyPageLink,
          }}
          newsletter={newsletterData}
          currentPageType={pageData.__typename}
        />
      )}

      <AnnouncementBarComponent announcements={announcementBar} positionStatically={positionStatically} />
    </>
  );
};
